export enum GeneroEnum {
    Acao = 1,
    Aventura = 2,
    Comedia = 3,
    Drama = 4,
    Romance = 5,
    Terror = 6,
    Suspense = 7,
    FiccaoCientifica = 8,
    Fantasia = 9,
    Animacao = 10,
    Documentario = 11,
    Musical = 12,
    Guerra = 13,
    Faroeste = 14,
    Misterio = 15
}